import { render, staticRenderFns } from "./EditAddress.vue?vue&type=template&id=f2e0f942&"
import script from "./EditAddress.vue?vue&type=script&lang=ts&"
export * from "./EditAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports